/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldMappingData } from './FieldMappingData';
import {
    FieldMappingDataFromJSON,
    FieldMappingDataFromJSONTyped,
    FieldMappingDataToJSON,
} from './FieldMappingData';

/**
 * 
 * @export
 * @interface SaveFieldMappingResponse
 */
export interface SaveFieldMappingResponse {
    /**
     * 
     * @type {FieldMappingData}
     * @memberof SaveFieldMappingResponse
     */
    mapping: FieldMappingData;
}

/**
 * Check if a given object implements the SaveFieldMappingResponse interface.
 */
export function instanceOfSaveFieldMappingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mapping" in value;

    return isInstance;
}

export function SaveFieldMappingResponseFromJSON(json: any): SaveFieldMappingResponse {
    return SaveFieldMappingResponseFromJSONTyped(json, false);
}

export function SaveFieldMappingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveFieldMappingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mapping': FieldMappingDataFromJSON(json['mapping']),
    };
}

export function SaveFieldMappingResponseToJSON(value?: SaveFieldMappingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mapping': FieldMappingDataToJSON(value.mapping),
    };
}

